module.exports = __webpack_public_path__ + "static/media/5.e04065f0.jpg";